import moment from "moment";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, ToastContainer, Toast, Modal, Form } from "react-bootstrap";

import { getErrorMessage } from "../../../utils/utils";
import { Validators } from "../../../shared/utils/Validators";
import { DropdownInput, TextInput } from "../../../shared/form/FormInput";
import { CalendarIcon, CopyIcon, FileTextIcon, UsersIcon } from "../../../shared/icons/Icons";
import { getApi, postApi, putApi } from "../../../shared/services/apiHelper";
import { assignmentList, responderLinkToken, runAssessmentClientList, runStatusUpdate, validateRunStatusUpdate } from "../../../shared/settings/apiConfig";

import './AssignmentList.scss';

const AssignmentList = (props) => {

    const getShareModalForm = () => {
        return {
            assessmentId: { value: "", error: "", valid: false, validators: [Validators.required()] },
            token: { value: "", error: "", valid: false, validators: [] }
        };
    };

    const user = useSelector((state) => { return state.user });

    const [runData, setRunData] = useState([]);
    const [runAssessmentData, setRunAssessmentData] = useState([]);
    const [shareModalForm, setShareModalForm] = useState(getShareModalForm());
    const [showLinkModal, setShowLinkModal] = useState({show: false, data: null});
    const [toastState, setToastState] = useState({ show: false, type: '', message: '' });

    useEffect(() => {
        getRunList().then(response => {
            setRunData(response.data);
        }).catch(error => {
            console.log(error);
        });
    }, []);

    useEffect(() => {
        if ( shareModalForm.assessmentId.value ) {
            generateLink(shareModalForm.assessmentId.value);
        }
    }, [shareModalForm.assessmentId.value]);

    const getAssessmentNames = (assessmentNames) => {
        return assessmentNames?.split(",").map((name, index) => (
            <span key={index} className="badge tag me-2">
                {name.trim()}
            </span>
        ));
    }

    const getRunList = async () => {
        let payload = {
            filter: [
                {
                    "field": "runtype",
                    "value": 3,
                    "op": "=",
                    "join": "AND"
                },
                {
                    "field": "responderid",
                    "value": null,
                    "op": "IS",
                    "join": "AND"
                }
            ],
            sort: [
                {
                    "field": "createddate",
                    "direction": "desc"
                }
            ],
            page: {
                size: 10
            }
        };
        if ( user?.rolename?.includes("Assesse") ) {
            payload.filter.push({
                "field": "clientid",
                "value": user.id,
                "op": "=",
                "join": "AND"
            });
            payload.field = ["id", "runname", "runtype", "runstatus", "respondersrequired", "expirydate", "rundate", "assessmentnames", "createddate", "assignmenttype"];
        } else {
            payload.field = ["id", "runname", "runtype", "respondersrequired", "expirydate", "rundate", "assessmentnames", 'assessecount', "createddate", "assignmenttype"];
        }

        try {
            const response = await postApi(assignmentList, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    const getRunAssessmentList = (id) => {
        let payload = {
            "field": ["id", "runassessmentid", "runid", "assessmentid", "assessmentname"],
            "filter": [
                {
                    "field": "runid",
                    "value": id,
                    "op": "=",
                    "join": "AND"
                },
                {
                    "field": "responderid",
                    "value": null,
                    "op": "IS",
                    "join": "AND"
                }
            ]
        }
        postApi(runAssessmentClientList, payload).then(response => {
            setRunAssessmentData(response.data.data.map(elem => { return { id: elem.id, value: elem.assessmentname }; }));
        }).catch(error => {
            console.log(error);
        })
    }

    const shareLinkModal = (runId) => {
        getRunAssessmentList(runId);
        setShowLinkModal({ show: true, data: null });
    }

    const closeLinkModal = () => {
        setShowLinkModal({ show: false, data: null });
        setShareModalForm(getShareModalForm());
    }

    const onShareModalInputChange = (type, value) => {
        let formControl = { ...shareModalForm };

        setShareModalForm(prevState => {
            prevState[type] = Validators.validateFormControl(formControl[type], value);
            return { ...prevState };
        });
    };

    const generateLink = (runAssessmentClientId) => {
        getApi(`${responderLinkToken}/${runAssessmentClientId}`).then(response => {
            setShareModalForm(prevState => {
                prevState.token.value = response.data.data.token;
                return {...prevState};
            });
        }).catch(error => {
            setToastState({ message: getErrorMessage(error), type: "danger", show: true });
        })
    };

    const getNavigateLink = () => {
        const origin = window.location.origin;
        const link = `${origin}/public/responder/${shareModalForm.token.value}`;
        return link;
    }

    const copyNavigateLink = () => {
        const link = getNavigateLink();
        navigator.clipboard.writeText(link).then(() => {
            setToastState({ message: "Link copied to clipboard", type: "success", show: true });
        }).catch(err => {
            setToastState({ message: "Failed to copy the link", type: "danger", show: true });
        });
    }

    const handleActions = async (item, startWork=false, submitWork=false) => {
        const payload = { runid: item.id };
        
        if ( startWork ) {
            putApi(runStatusUpdate, { data: payload }).then(response => {
                getRunList().then(response => {
                    setRunData(response.data);
                }).catch(error => {
                    console.log(error);
                });
            }).catch(error => {
                console.log(error);
            });
        } else if ( submitWork ) {
            postApi(validateRunStatusUpdate, { data: payload }).then(response => {
                props.history.push(`/assignments/submit-analysis/${item.id}`);
            }).catch(error => {
                setToastState({show: true, message: getErrorMessage(error), type: 'warning'});
            });
        }
    };

    return (
        <div className="main-content assignment-container">
            <div className="d-flex align-items-center justify-content-between">
                <h3 className="fw-bold">{user?.rolename?.includes("Assesse") ? "My Assignments" : "Assignments"}</h3>
                { !user?.rolename?.includes("Assesse") && <Button variant="primary" onClick={() => props.history.push('/assignments/create')}>+ Create Assignment</Button> }
            </div>

            {
                runData.map((item, index) => (
                    <div className="assignment-card card-view" key={index}>
                        <div className="header">
                            <h5 className="fw-bold">{item.runname}</h5>
                            <div className="d-flex align-items-center text-muted-label gap-3">
                                <div className="d-flex align-items-center gap-1">
                                    <CalendarIcon />
                                    <div>Due: {moment.utc(item.expirydate).format("MMM DD, YYYY")}</div>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                    {
                                        user?.rolename?.includes("Assesse") ? 
                                        <>
                                            <FileTextIcon />
                                            {item.assessmentnames?.split(',').length} Assessments
                                        </> : 
                                        <>
                                            <UsersIcon />
                                            {item.assessecount} students
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-1">
                            <div className="fw-bold">{item.assignmenttype == 1 ? 'Tool / Instrument' : 'Submission Assessment'}</div>
                            <div className="d-flex gap-2">
                                {getAssessmentNames(item.assessmentnames)}
                            </div>
                        </div>

                        {
                            item.assignmenttype == 1 ?
                            <div className="d-flex align-items-center gap-2">
                                {
                                    user?.rolename?.includes("Assesse") ? 
                                    <>
                                        <div className="fw-bold">Peer Review Required:</div>
                                        <div>You need at least {item.respondersrequired || 0} peer response(s)</div>
                                    </> : 
                                    <>
                                        <UsersIcon />
                                        <div>Min {item.respondersrequired || 0} Respondents Required</div>
                                    </>
                                }
                            </div> : null
                        }

                        <div className="assign-btn">
                            <span className="text-muted-label">
                                {user?.rolename?.includes("Assesse") ? 'Assigned' : 'Created'} {moment.utc(item.rundate).format('DD/MM/YYYY')}
                            </span>

                            <div className='d-flex gap-2'>
                                <Button variant="outline-primary" className="variant" onClick={() => props.history.push(`/assignments/assignment-view/${item.id}`)}>View Details</Button>
                                {
                                    user?.rolename?.includes("Assesse") && 
                                    <>
                                        {
                                            item.runstatus == 'Not Started' && <Button variant="primary" onClick={() => handleActions(item, true)}>Start Work</Button>
                                        }
                                        {
                                            item.assignmenttype == 1 && item.runstatus == 'In Progress' && <Button variant="secondary" onClick={() => shareLinkModal(item.id)}>Share</Button>
                                        }
                                        {
                                            item.runstatus == 'In Progress' && <Button variant="secondary" onClick={() => handleActions(item, false, true)}>Submit Work</Button>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                ))
            }

            {
                runData.length == 0 && 
                <div className="d-flex align-items-center justify-content-center" style={{padding: '5rem'}}>
                    <div>No Assignment(s) Yet</div>
                </div>
            }

            <Modal centered show={showLinkModal.show} size='lg' onHide={() => closeLinkModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>Share Assessment Link</Modal.Title>
                </Modal.Header>
                <Modal.Body className="share-modal-body">
                    <div className='assessment-row mt-2'>
                        <DropdownInput label="Tool / Instrument" name='assessment' defaultValue="Select Assessment" value={shareModalForm.assessmentId.value} options={runAssessmentData} onChange={(value) => { onShareModalInputChange('assessmentId', value); }} />
                        <span>
                            {
                                runAssessmentData.length == 0 ? <span className='text-s text-info'>No assessment(s) available</span> : null
                            }
                        </span>
                        <span className='text-danger'>
                            {
                                shareModalForm.assessmentId.error ? <small className="error">{shareModalForm.assessmentId.error}</small> : null
                            }
                        </span>
                    </div>

                    {
                        shareModalForm.assessmentId.value && shareModalForm.token.value && (
                            <div className="d-flex flex-column">
                                <div className="d-flex gap-2">
                                    <TextInput type="text" label="Assessment Link" readOnly value={getNavigateLink()}  />
                                    <div className="link-copy" onClick={copyNavigateLink}>
                                        <CopyIcon />
                                    </div>
                                </div>
                                <p className='mt-2'>This link allows respondents to provide feedback on your work</p>
                            </div>
                        )
                    }
                </Modal.Body>
                <Modal.Footer className='d-flex align-items-center justify-content-center'>
                    <Button variant="secondary" onClick={() => closeLinkModal()}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
                <Toast show={toastState.show} bg={toastState.type} onClose={() => setToastState({ ...toastState, show: false })} autohide delay={2000}>
                    <Toast.Body className="text-white">
                        {toastState.message}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};

export default AssignmentList;